module.exports = __webpack_public_path__ + "img/pensive.33fa5871.png";